<template>
  <tk-container class="runTime" :status="status">
    <tkui-header center slot="header">
      <tk-icon slot="left-menu" @click.native="back">Return</tk-icon>
      运行时间
      <span slot="right-menu" @click="setConfig">设置</span>
    </tkui-header>
    <div class="body">
      <p class="name">设置开关机时间</p>
      <div class="item">
        <p class="itemName">选择星期</p>
        <tk-flex wrap>
          <tk-flex middle class="tk-grid-4" v-for="(item, index) in date" :key="index">
            <div class="dateBtn" :class="{'selected': dateSelected.includes(item)}" @click="select(item)">{{item}}</div>
          </tk-flex>
        </tk-flex>
      </div>
      <div class="item">
        <tk-flex middle between>
          <p class="itemName">时间设置</p>
        </tk-flex>
        <tk-flex middle between class="timeBox">
          <p class="itemName" style="margin-bottom: 0">开机</p>
          <div class="picker">
            <tkui-list style="position: absolute;width: 100%;height: 20px;opacity: 0;left: 0;top: 0;">
              <tkui-list-picker v-model="start" :items="timeList" label=""></tkui-list-picker>
            </tkui-list>
            <p class="time" v-if="start.length === 3 && start[0] !== '' && start[2] !== ''">{{start.join('')}}</p>
            <tk-icon v-else style="color:#999999;height: 16px;">return_copy</tk-icon>
          </div>
        </tk-flex>
        <tk-flex middle between class="timeBox">
          <p class="itemName" style="margin-bottom: 0">关机</p>
          <div class="picker">
            <tkui-list style="position: absolute;width: 100%;height: 20px;opacity: 0;left: 0;top: 0;">
              <tkui-list-picker v-model="end" :items="timeList" label=""></tkui-list-picker>
            </tkui-list>
            <p class="time" v-if="end.length === 3 && end[0] !== '' && end[2] !== ''">{{end.join('')}}</p>
            <tk-icon v-else style="color:#999999;height: 16px;">Return1</tk-icon>
          </div>
        </tk-flex>
      </div>
      <div class="item">
        <tk-flex middle between class="timeBox">
          <p class="itemName2">高水位运行时间</p>
          <div class="picker">
            <tkui-list style="position: absolute;width: 100%;height: 20px;opacity: 0;left: 0;top: 0;">
              <tkui-list-picker v-model="highWaterTime" :items="timeList" label=""></tkui-list-picker>
            </tkui-list>
            <p class="time2" v-if="highWaterTime.length === 3 && highWaterTime[0] !== '' && highWaterTime[2] !== ''">{{highWaterTime.join('')}}</p>
            <tk-icon v-else style="color:#999999;height: 16px;">return_copy</tk-icon>
          </div>
        </tk-flex>
      </div>
      <div class="item">
        <tk-flex middle between class="timeBox">
          <p class="itemName2">低水位运行时间</p>
          <div class="picker">
            <tkui-list style="position: absolute;width: 100%;height: 20px;opacity: 0;left: 0;top: 0;">
              <tkui-list-picker v-model="lowWaterTime" :items="timeList" label=""></tkui-list-picker>
            </tkui-list>
            <p class="time2" v-if="lowWaterTime.length === 3 && lowWaterTime[0] !== '' && lowWaterTime[2] !== ''">{{lowWaterTime.join('')}}</p>
            <tk-icon v-else style="color:#999999;height: 16px;">return_copy</tk-icon>
          </div>
        </tk-flex>
      </div>
    </div>
  </tk-container>
</template>

<script>
  import time from '../../../assets/js/time'
  var timeList = [
    time.hour, [':'], time.minute
  ]
  export default {
    data () {
      return {
        lowWaterTime: [],
        highWaterTime: [],
        date: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        start: [],
        end: [],
        timeList: timeList,
        dateSelected: [],
        status: false,
        machineStatus: {}
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine
      },
      user () {
        return this.$store.state.user.objectId
      }
    },
    created () {
      this.initStatus()
    },
    methods: {
      async initStatus () {
        try {
          this.status = 'loading'
          let status = await this.$tkParse.getList('/classes/status', {
            'params': {
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          if (status[0]) {
            this.machineStatus = status[0]
            this.initData(status[0])
          }
          this.status = false
        } catch (e) {
          this.status = false
          this.$tkGlobal.toast.add('获取设备状态失败')
        }
      },
      initData (status) {
        this.dateSelected = [...status.runWorkday]
        this.start = [status.startHour.toString().padStart(2, '0'), ':', status.startMinute.toString().padStart(2, '0')]
        this.end = [status.endHour.toString().padStart(2, '0'), ':', status.endMinute.toString().padStart(2, '0')]
        this.highWaterTime = [status.highWaterHour.toString().padStart(2, '0'), ':', status.highWaterMinute.toString().padStart(2, '0')]
        this.lowWaterTime = [status.lowWaterHour.toString().padStart(2, '0'), ':', status.lowWaterMinute.toString().padStart(2, '0')]
      },
      back () {
        this.$back()
      },
      async setConfig () {
        try {
          let res = await this.$tkParse.getData(`/classes/machine/${this.machine.objectId}`)
          if (!res.online) {
            if (JSON.stringify(this.machineStatus) !== '{}') {
              this.initData(this.machineStatus)
            }
            this.status = false
            this.$tkGlobal.toast.add('设备离线，无法设置')
            return
          }
          this.status = 'waiting'
          let status = {}
          status.runWorkday = this.dateSelected
          if (this.start.length === 3) {
            status.startHour = Number(this.start[0])
            status.startMinute = Number(this.start[2])
          }
          if (this.end.length === 3) {
            status.endHour = Number(this.end[0])
            status.endMinute = Number(this.end[2])
          }
          if (this.lowWaterTime.length === 3) {
            status.lowWaterHour = Number(this.lowWaterTime[0])
            status.lowWaterMinute = Number(this.lowWaterTime[2])
          }
          if (this.highWaterTime.length === 3) {
            status.highWaterHour = Number(this.highWaterTime[0])
            status.highWaterMinute = Number(this.highWaterTime[2])
          }
          await this.$cloudAjax.post('/index/setConfig', {
            'machine': this.machine.objectId,
            'status': status,
            'type': '运行时间',
            'user': this.user,
            'deviceId': this.machine.deviceId
          })
          this.status = false
          this.$tkGlobal.toast.add('设置成功')
        } catch (e) {
          this.initData(this.machineStatus)
          this.status = false
          this.$tkGlobal.toast.add('设置失败')
        }
      },
      select (item) {
        let index = this.dateSelected.indexOf(item)
        if (index !== -1) {
          this.dateSelected.splice(index, 1)
        } else {
          this.dateSelected.push(item)
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .body{
    p {
       margin-bottom: 0;
     }
    padding-bottom: 1px;
    .name{
      padding-left: 15px;
      height: 33px;
      line-height: 33px;
      font-size: 14px;
      color: #999999;
      margin-bottom: 0!important;
    }
    .item{
      padding: 15px;
      background: #ffffff;
      margin-bottom: 10px;
      .timeBox{
        height: 50px;
        border-bottom: 1px solid #EBF5FD;
        .picker{
          position: relative;
          width:50px;
          height:20px;
          text-align: right;
          .time{
            color: #333333;
            font-size: 16px;
            font-weight: 700;
          }
          .time2{
            color: #666666;
            font-size: 14px;
          }
        }
      }
      .itemName{
        font-size: 14px;
        color: #999999;
        margin-bottom: 5px;
      }
      .dateBtn{
        width: 90px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #666666;
        background: #EBF5FD;
        margin-bottom: 15px;
        border-radius: 4px;
        font-size: 16px;
      }
      .selected{
        background: #0091FF;
        color: #ffffff;
      }
      .itemName2{
        color: #333333;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0!important;
      }
      .val2{
        font-size: 14px;
        color: #666666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/remote/runTime.vue